import { SET_LOADING_ACCOUNTING_INTEGRATION, STORE_COMPANY, STORE_COMPANY_ACCOUNTING_INTEGRATION, STORE_COMPANY_POLICY } from '@Actions/company';
export function companyReducer(state = { company: (window.AbacusDataManagerSeed && window.AbacusDataManagerSeed.org) || window.ORG }, action) {
    switch (action.type) {
        case STORE_COMPANY:
            return Object.assign(Object.assign({}, state), { company: action.company });
        case STORE_COMPANY_POLICY:
            return Object.assign(Object.assign({}, state), { policy: action.companyPolicy });
        case STORE_COMPANY_ACCOUNTING_INTEGRATION:
            return Object.assign(Object.assign({}, state), { accountingIntegration: action.accountingIntegration });
        case SET_LOADING_ACCOUNTING_INTEGRATION:
            return Object.assign(Object.assign({}, state), { loadingAccountingIntegration: action.loading });
        default:
            return state;
    }
}
